import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Container, Row, Col, Table, Spinner } from "react-bootstrap";
import {
  getDetailTransaction,
  getInternalTransaction,
  getlogsTransaction,
  getTokentransfer,
} from "./ApiCall";
import InnerHTML from "dangerously-set-html-content";
import Loader from "./Loader";
import MainComponent from "./MainComponent";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ScrollToTop from "../Components/ScrollToTop";
import { toast } from "react-toastify";
import TabComponent from "./TabComponent";
function TransactionDetail() {
  const { eventKey } = useParams();
  const [activeTab, setActiveTab] = useState(eventKey || "details");
  const [transaction, setTransaction] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [internaltransaction, setinternalTransaction] = useState();
  const [logtransaction, setlogTransaction] = useState();
  const [tokentransfer, setTokentransfer] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();

  let transactionId = window.location.pathname?.split("/")[2];
  const fetchData = () => {
    setLoading(true);
    getDetailTransaction(transactionId)
      .then((transactionResponse) => {
        setTransaction(transactionResponse);
        setLoading(false);
        setError(false);
      })
      .catch((error) => {
        setError(true);
        // toast.error("Network error Please try again later.");
        setLoading(false);
      });
  };
  const fetchinternal = () => {
    getInternalTransaction(transactionId).then((blockResponse) => {
      setinternalTransaction(blockResponse);
      setLoading(false);
    });
  };

  const fetchlog = () => {
    getlogsTransaction(transactionId).then((blockResponse2) => {
      setlogTransaction(blockResponse2);
      setLoading(false);
    });
  };

  const fetchtoken = () => {
    getTokentransfer(transactionId).then((blockResponse3) => {
      setTokentransfer(blockResponse3);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
    fetchinternal();
    fetchlog();
    fetchtoken();
    let params = new URLSearchParams(location.search).get("tab");

    if (params) {
      setActiveTab(params);
    }
    const handlePopState = () => {};
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location]);

  const TextToHtml = ({ text }) => {
    return (
      <div>
        <InnerHTML html={text} />
      </div>
    );
  };
  window.Navigateto = (tabName) => {
    if (tabName !== window.location.pathname) {
      navigate(tabName);
    } else {
      return false;
    }
  };

  const handleTabSelect = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      setSearchParams(
        (params) => {
          params.set("tab", tab);
          return params;
        },
        { replace: true }
      );
    }
  };
  const tabs = [
    {
      eventKey: "details",
      title: "Overview",
      content: loading ? (
        <Loader />
      ) : transaction?.data ? (
        <TextToHtml text={transaction?.data.replaceAll("WOOOO", "AMG")} />
      ) : (
        <Loader />
      ),
    },
    {
      eventKey: "internalTxns",
      title: "InternalTxns",
      content: loading ? (
        <Loader />
      ) : internaltransaction?.data?.data ? (
        <TextToHtml text={internaltransaction?.data?.data} />
      ) : (
        <Loader />
      ),
    },
    {
      eventKey: "Logs",
      title: "Logs",
      content: loading ? (
        <Loader />
      ) : logtransaction?.data ? (
        <TextToHtml text={logtransaction?.data} />
      ) : (
        <Loader />
      ),
    },
    {
      eventKey: "TokenTransfer",
      title: "Token Transfer",
      content: loading ? (
        <Loader />
      ) : tokentransfer?.data ? (
        <TextToHtml text={tokentransfer?.data?.data} />
      ) : (
        <Loader />
      ),
    },
  ];

  return (
    <>
      <div className="main-inner">
        <div className="container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" md="12">
                  <h2>Transaction Details</h2>

                  {error ? (
                    <div className="table-container">
                      <div className="table-inner-container"></div>
                      <div className="errorMsg">
                        <span>Search Not Found </span>
                      </div>
                    </div>
                  ) : (
                    <TabComponent
                      activeTab={activeTab}
                      handleTabSelect={handleTabSelect}
                      tabs={tabs}
                    />
                  )}
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
      <ScrollToTop />
    </>
  );
}

export default TransactionDetail;
